export default __webpack_public_path__ + "static/media/grey-tick.38df54fe.svg";